import {
  User,
  Sun,
  Moon,
  RotateCw,
  ChevronRight,
  ChevronLeft,
  Menu,
} from "lucide-react";
import { useLocation } from "react-router-dom";
import { useThemeStore } from "../../store/themeStore";

interface HeaderProps {
  isSidebarOpen: boolean;
  setSidebarOpen: (isOpen: boolean) => void;
  setMobileMenuOpen: (isOpen: boolean) => void;
}

const Header = (props: HeaderProps) => {
  const location = useLocation();

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const currentPage = pathSegments[pathSegments.length - 1] || "Dashboard";
  const { isSidebarOpen, setSidebarOpen, setMobileMenuOpen } = props;
  // Note: These props are kept for compatibility but not used in the exact-match UI layout
  console.log(isSidebarOpen, setSidebarOpen, setMobileMenuOpen);

  const formattedTitle =
    currentPage.charAt(0).toUpperCase() +
    currentPage.slice(1).replace("-", " ");

  const { theme, toggleTheme } = useThemeStore();

  return (
    // <header className="h-[70px] bg-white/80 dark:bg-[#0b1437]/80 backdrop-blur-xl border-b border-slate-100 dark:border-white/10 flex items-center justify-between px-6 md:px-10 sticky top-0 z-40 transition-all duration-300">
    <header className="relative h-[70px] bg-white/80 dark:bg-[#0b1437]/80 backdrop-blur-xl border-b border-slate-100 dark:border-white/10 flex items-center justify-between px-4 md:px-10 top-0 z-40 transition-all duration-300">
      <div className="flex items-center flex-1">
        {/* Back Arrow & Breadcrumbs */}
        <button
          onClick={() => setMobileMenuOpen(true)}
          className="lg:hidden p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-all"
        >
          <Menu size={22} />
        </button>
        <div className="flex items-center gap-4">
          <button
            onClick={() => setSidebarOpen(!isSidebarOpen)}
            className="hidden lg:block p-2 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-50 dark:hover:bg-[#111c44] transition-all"
          >
            {isSidebarOpen ? (
              <ChevronLeft size={20} />
            ) : (
              <ChevronRight size={20} />
            )}
          </button>

          {/* <div className="flex flex-col"> */}
          {/* <div className="flex flex-col flex-1 items-center lg:items-start text-center lg:text-left"> */}
          <div className="flex flex-col items-center text-center lg:static absolute left-1/2 -translate-x-1/2 lg:translate-x-0 lg:text-left">
            {/* <div className="flex items-center gap-1.5 text-[11px] font-medium text-slate-400 dark:text-slate-500 mb-0.5"> */}
            <div className="hidden lg:flex items-center gap-1.5 text-[11px] font-medium text-slate-400 dark:text-slate-500 mb-0.5">
              <span>Home</span>
              <ChevronRight
                size={10}
                className="text-slate-300 dark:text-slate-600"
              />
              <span className="text-slate-500 dark:text-slate-400">
                {formattedTitle}
              </span>
            </div>
            <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100 leading-none">
              {formattedTitle}
            </h1>
          </div>
        </div>
      </div>

      {/* <div className="flex items-center gap-6"> */}
      <div className="flex items-center gap-4 ml-auto">
        {/* Theme Toggle & Refresh */}
        {/* <div className="flex items-center gap-4"> */}
        <div className="hidden lg:flex items-center gap-4">
          {/* Switch-style toggle */}
          <button
            type="button"
            onClick={toggleTheme}
            className={`flex items-center transition-all duration-300 p-1 rounded-full w-14 h-7 relative shadow-inner cursor-pointer ${
              theme === "dark" ? "bg-indigo-600" : "bg-slate-200"
            }`}
          >
            <div
              className={`flex items-center justify-center w-5 h-5 bg-white rounded-full shadow-sm transition-transform duration-300 ${
                theme === "dark" ? "translate-x-7" : "translate-x-0"
              }`}
            >
              {theme === "dark" ? (
                <Moon size={12} className="text-indigo-600 fill-indigo-600" />
              ) : (
                <Sun size={12} className="text-amber-500 fill-amber-500" />
              )}
            </div>
          </button>

          <button className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-all">
            <RotateCw size={20} />
          </button>
        </div>

        {/* <div className="h-8 w-px bg-slate-200 dark:bg-white/10" /> */}
        <div className="hidden md:block h-8 w-px bg-slate-200 dark:bg-white/10" />

        <div className="flex items-center gap-3 group cursor-pointer">
         <div className="hidden md:flex flex-col items-end">
            <span className="text-sm font-bold text-slate-800 dark:text-slate-200 leading-none mb-1">
              Super Admin
            </span>
            <span className="text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wider">
              Administrator
            </span>
          </div>
          <div className="w-10 h-10 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 flex items-center justify-center border border-blue-100 dark:border-blue-800 overflow-hidden shadow-sm">
            <User size={20} className="stroke-2" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
